<template>
  <section class="index-initial flex flex-wrap w-full h-screen bg-cover bg-center bg-no-repeat relative">
    <debug-landing-trigger></debug-landing-trigger>
    <div class="w-full mx-auto index-initial__ctn relative z-10">
        <img class="text-center w-full mb-32 mx-auto max-w-md block" src="@/assets/images/logo.svg">
        <ul class="list-reset w-full text-center flex items-stretch flex-no-wrap px-20">
            <li v-for="page in sitemap" :key="page.id" class="index-initial__nav-btn mr-4 inline-block bg-white rounded no-underline uppercase text-4xl flex items-center flex-1">
                <template v-if="page.children">
                  <a href="#" class="inline-block w-full no-underline text-grey-darkest hover:text-red-dark sans-bd w-full px-2 py-12" @click.prevent="showSub(page.uri)" :class="{'active' : visibleSub === page.uri }">{{ page.title }}</a>
                </template>
                <router-link class="text-grey-darkest no-underline"  v-else :to="page.uri">{{ page.title }}</router-link>
            </li>
        </ul>
          <ul class="list-reset w-full text-center flex flex-no-wrap flex-start px-20">
            <li class="flex-1 mr-4" v-for="page in sitemap" :key="page.id">
              <transition name="fade">
                <ul v-if="visibleSub === page.uri" class="list-reset uppercase">
                    <li class="mt-4" v-for="child in page.children" :key="child.id">
                      <router-link class="bg-white hover:bg-red-dark rounded block text-lg py-2 no-underline sans tracking-wide text-grey-darkest hover:text-white" v-if="child.type == 'contentPage'" :to="child.uri">{{ child.title }}</router-link>
                      <template v-else>
                        <template v-if="child.children" v-for="(content, index) in child.children">
                          <router-link class="bg-white hover:bg-red-dark rounded block py-2 text-lg text-grey-darkest hover:text-white no-underline sans" v-if="index === 0" :key="index" :to="content.uri">{{ child.title }}</router-link>
                        </template>
                        <template v-else>
                          No Content page set
                        </template>
                      </template>
                    </li>
                </ul>
              </transition>
            </li>
        </ul>
        <transition enter-active-class="animated fadeIn fast">
          <p v-if="showTeaseText" class="index-initial__tts sans text-center uppercase text-white text-2xl absolute w-full">Touch a button to start</p>
        </transition>
    </div>
    <preload-images></preload-images>
  </section>
</template>
<script>
import DebugLandingTrigger from '../components/debug/DebugLandingTrigger'
import PreloadImages from '../components/PreloadImages'

export default {
  name: 'LandingPage',
  components: {
    'debug-landing-trigger': DebugLandingTrigger,
    'preload-images': PreloadImages
  },

  data () {
    return {
      visibleSub: null
    }
  },

  mounted () {
    this.visibleSub = this.$route.path
  },

  activated () {
    this.visibleSub = this.$route.path
  },

  computed: {
    sitemap () {
      return this.$store.getters['pages/sitemap']
    },
    showTeaseText () {
      return (this.visibleSub === null) || (this.visibleSub === '/')
    }
  },

  methods: {
    showSub (uri) {
      if (this.visibleSub === uri) {
        this.visibleSub = null
      } else {
        this.visibleSub = uri
      }
    }
  }
}
</script>
